// @ts-nocheck
import React, { useState, useCallback } from 'react';
import { goBack } from '../../lib/helpers';
import { overhaulTypeApi } from '../../lib/api';
import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';
const entryPointPath = '/admin/overhaul-types/';
export default props => {
  const [data, setData] = useState({
    id: props.id
  });
  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);
  const onFetch = useCallback(async () => {
    !!props.id && setData(await overhaulTypeApi.get(props.id));
  }, [props.id]);
  const onSubmit = async payload => {
    let id = payload.id;
    if (id) {
      await overhaulTypeApi.update(payload);
    } else {
      let data = await overhaulTypeApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };
  const onCancel = async payload => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };
  return <CommonCardPage pageHeaderProps={{
    breadCrumbs,
    mainHeader: 'Виды работ по капитальному ремонту ТС'
  }} onFetch={onFetch} onSubmit={onSubmit} onCancel={onCancel}>
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>;
};
